// 配置API接口地址
var root = process.env.API_ROOT
// 引用axios
var axios = require('axios')

import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
// import that from 'vue-router';
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

axios.defaults.retry = 4;
axios.defaults.retryDelay = 3000;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config);
  });
});

function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }

  let baseURL,type = 1;
  if(sessionStorage.getItem('type')){
    type = Number(sessionStorage.getItem('type'))
  }
  
  if (type == 1) {
    // 黑龙江
    baseURL = 'https://coupon.xinquanyu.top/index.php/api'
  } else if (type == 2) {
    // 山东
    baseURL = 'http://sdcoupon.xinquanyu.top/index.php/api'
  } 
  console.log(baseURL)
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: baseURL,
    headers: {'Content-Type': 'application/json; charset=utf-8'},
    withCredentials: false
  })
    .then(function (res) {
      if (res.data.code === 1) {
        if (success) {
          success(res.data)
        }
      } else if (res.data.code === 401) {
        Toast(res.data.msg)
        window.sessionStorage.removeItem('token');
        window.location.reload();
      } else {
        if (failure) {
          failure(res.data)
        } else {
          Toast(res.data.msg)
        }
      }
    })
    .catch(function (err) {
      let res = err.response
      if (res.data.code === 401) {
        window.sessionStorage.removeItem('token');
        window.location.reload();
      }
    })
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js